import { useEffect, useState, useCallback } from "react";
import { AppUser , Subject} from "../serverlib/util-types";
import { getTopics, addTopic, editTopic, delTopic , getAppUser , addSubtopic} from "../serverlib/db";
import { User } from "firebase/auth";
import { useTranslation } from "react-i18next";

//icons
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

interface DeleteConfirmModalProps {
    name: string;
    onConfirm: () => void;
    onCancel: () => void;
}
const DeleteConfirmModal = ({ name, onConfirm, onCancel }: DeleteConfirmModalProps) => {
    const { t } = useTranslation("common");
    const [input, setInput] = useState('');
    const keyword = t("admin.delete-modal-keyword");
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            background: 'rgba(0,0,0,0.55)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', padding: '16px'
        }} onClick={onCancel}>
            <div style={{
                background: 'var(--grey-secondary)', borderRadius: 12,
                padding: '24px 28px', maxWidth: 420, width: '100%',
                boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
            }} onClick={e => e.stopPropagation()}>
                <p style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>
                    {t("admin.delete-modal-title", { name })}
                </p>
                <p style={{ fontSize: 13, marginBottom: 16, opacity: 0.75 }}
                    dangerouslySetInnerHTML={{ __html: t("admin.delete-modal-body") }} />
                <input
                    className="admin-input"
                    type="text"
                    autoFocus
                    placeholder={t("admin.delete-modal-placeholder")}
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter' && input === keyword) onConfirm(); }}
                    style={{ width: '100%', marginBottom: 16, boxSizing: 'border-box' }}
                />
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button className="admin-button hover-up" type="button" onClick={onCancel}>
                        {t("admin.delete-modal-cancel")}
                    </button>
                    <button
                        className="admin-button hover-up"
                        type="button"
                        disabled={input !== keyword}
                        onClick={onConfirm}
                        style={{
                            background: input === keyword ? 'var(--error-color, #e05252)' : 'var(--grey-tertiary)',
                            color: 'var(--text-primary)',
                            opacity: input === keyword ? 1 : 0.5,
                            transition: 'background 0.15s, opacity 0.15s'
                        }}
                    >
                        {t("admin.delete-modal-confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};
interface TopicPageProps {
    user: User | null;
    subjectfromurl : Subject | null;
    gradefromurl : string | null ;
}

const TopicsPage = (props: TopicPageProps) => {
    const { t } = useTranslation("common");

    const [availableSubjects, setAvailableSubjects] = useState<string[] |null>([]);
    const [appUser, setAppUser] = useState<AppUser | null>(null);
    const [subject, setSubject] = useState<Subject | ''>(props.subjectfromurl as Subject); // Initialize subject state with empty string
    const [grade, setGrade] = useState("");

    //KOPYAMAKARNA

    const [topics, setTopics] = useState<string[]>([]);
    const [subtopics, setSubtopics] = useState<{ [topic: string]: string[] }>({});
    const [newTopic, setNewTopic] = useState('');
    const [newSubtopic] = useState('');
    const [subtopicInputs, setSubtopicInputs] = useState<{ [topic: string]: string }>({});

    /*TOPICCCCCCCSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS */

    const [editingInfo, setEditingInfo] = useState<{ topic: string | null, newName: string | null }>({ topic: null, newName: null });
    const [editingSubtopicInfo, setEditingSubtopicInfo] = useState<{ topic: string | null, index: number | null, newName: string | null }>({ topic: null, index: null, newName: null });
    // pending delete modal state
    const [pendingDelete, setPendingDelete] = useState<{ type: 'topic' | 'subtopic', topic: string, index?: number, label: string } | null>(null);

    const getExistingTopics = useCallback(async () => {
        try {
            console.log("subject topic: ", subject);
            console.log("grade topic: ", grade);
            const existingTopics = await getTopics(subject as Subject, "subjects"+grade);
            setTopics(existingTopics.map((topic) => topic.tname));
            setSubtopics(existingTopics.reduce((acc: { [topic: string]: string[] }, topic) => {
                acc[topic.tname] = topic.subtopics;
                return acc;
            }, {}));
        } catch (error) {
            console.error("Error getting existing topics:", error);
        }
    }, [subject, grade]);
    useEffect(() => {
        if (grade !== '' && subject !== '') {
            getExistingTopics();
        }
    }, [grade, subject, props.gradefromurl, props.subjectfromurl, props.user, getExistingTopics]);

    const handleAddTopic = async () => {
        if (newTopic.trim() !== '') {
            try {
                const topicId = await addTopic(subject as Subject, grade, newTopic);
                if (topicId !== null) {
                    setTopics([...topics, newTopic]);
                    setSubtopics({ ...subtopics, [newTopic]: [] });
                    setNewTopic('');
                    console.log("added topicId: ", topicId);
                }
            } catch (error) {
                console.error("Error adding topic:", error);
            }
        }
    };

    const handleAddSubtopic = async (topic: string) => {
        const newSubtopicValue = (subtopicInputs[topic] ?? '').trim();

        if (newSubtopicValue !== '') {
            setSubtopics({
                ...subtopics,
                [topic]: [...(subtopics[topic] || []), newSubtopicValue],
            });
            setSubtopicInputs({ ...subtopicInputs, [topic]: '' });

            // Update the subtopics in Firestore
            try {
                const resAddSubTopic = await addSubtopic(subject as Subject, grade, topic, newSubtopicValue);
                if (resAddSubTopic !== null) {
                    console.log("res: ", resAddSubTopic);
                }
            } catch (error) {
                console.error("Error updating subtopics:", error);
            }
        }
    };

    const handleDeleteTopic = async (topic: string) => {
        // Delete the topic from Firestore
        try {
            await delTopic(subject as Subject, grade, topic);
        } catch (error) {
            console.error("Error deleting topic:", error);
        }

        // Update the state
        const updatedTopics = [...topics].filter((t) => t !== topic);
        const updatedSubtopics = { ...subtopics };
        delete updatedSubtopics[topic];

        setTopics(updatedTopics);
        setSubtopics(updatedSubtopics);
    };

    const handleDeleteSubtopic = async (topic: string, index: number) => {
        const updatedSubtopics = { ...subtopics };
        updatedSubtopics[topic].splice(index, 1);

        setSubtopics(updatedSubtopics);

        // Update the subtopics in Firestore
        try {
            await editTopic(subject as Subject, grade, topic, topic, updatedSubtopics[topic]);
        } catch (error) {
            console.error("Error updating subtopics:", error);
        }
    };

    const handleEditTopic = (topic: string) => {
        setEditingInfo({ topic, newName: topic });
    };

    const handleSaveTopic = async (topic: string, newName: string) => {
        setEditingInfo({ topic: null, newName: null });
        if (newName !== topic) {
            const updatedTopics = topics.map((t) => (t === topic ? newName : t));
            const updatedSubtopics = { ...subtopics };
            updatedSubtopics[newName] = updatedSubtopics[topic];
            delete updatedSubtopics[topic];

            setTopics(updatedTopics);
            setSubtopics(updatedSubtopics);

            // Update the topic in Firestore
            try {
                await editTopic(subject as Subject, grade, topic, newName, updatedSubtopics[newName]);
            } catch (error) {
                console.error("Error updating topic:", error);
            }
        }
    };

    const handleEditSubtopic = (topic: string, subtopicIndex: number) => {
        setEditingSubtopicInfo({ topic, index: subtopicIndex, newName: subtopics[topic][subtopicIndex] });
    };

    const handleSaveSubtopic = async (topic: string, index: number, newName: string) => {
        setEditingSubtopicInfo({ topic: null, index: null, newName: null });
        if (newName !== subtopics[topic][index]) {
            const updatedSubtopics = { ...subtopics };
            updatedSubtopics[topic][index] = newName;

            setSubtopics(updatedSubtopics);

            // Update the subtopics in Firestore
            try {
                await editTopic(subject as Subject, grade, topic, topic, updatedSubtopics[topic]);
            } catch (error) {
                console.error("Error updating subtopics:", error);
            }
        }
    };

    // const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, topic: string, index: number | null, isTopic: boolean) => {
    //     if (event.key === 'Enter') {
    //         event.preventDefault();
    //         if (isTopic) {
    //             if (topics.includes(newTopic)) {
    //                 handleSaveTopic(topic, editingInfo.newName || '');
    //             } else {
    //             handleAddTopic();
    //             }
    //         } else {
    //             if (subtopics[topic].includes(newSubtopic)) {
    //                 handleSaveSubtopic(topic, index || 0, editingSubtopicInfo.newName || '');
    //             } else {
    //             handleAddSubtopic(topic);
    //             }
    //             // handleSaveSubtopic(topic, index || 0, editingSubtopicInfo.newName || '');
    //         }
    //     }
    // };

    const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>, topic: string, index: number | null, isTopic: boolean) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (isTopic) {
                if (topics.includes(newTopic)) {
                    handleSaveTopic(topic, editingInfo.newName || '');
                } else {
                    await handleAddTopic();
                }
            } else {
                if (subtopics[topic].includes(newSubtopic)) {
                    handleSaveSubtopic(topic, index || 0, editingSubtopicInfo.newName || '');
                } else {
                    await handleAddSubtopic(topic);
                }
            }
        }
    };

    /*TOPICCCCCCCSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS end*/

    var gradeint = String(grade.match(/\d+/g));
    if (gradeint === "null") {
        gradeint = "Prep";
    }
    const getAvailableSubjects = useCallback(async () => {
        //use firestore to get available subjects
        let resolvedGradeint = gradeint;
        if (resolvedGradeint === "null") {
            resolvedGradeint = props.gradefromurl as string;
        }
        console.log("gradeint TOPICS: ", resolvedGradeint);
        console.log("props.gradefromurl TOPICS: ", props.gradefromurl);
        const result = require(`../data/subjectsgeneralized.json`);
        const subjects = result[resolvedGradeint as string];
        setAvailableSubjects(subjects as string[]);
    }, [gradeint, props.gradefromurl]);

    useEffect(() => {
        getAvailableSubjects();
    }, [gradeint, props.gradefromurl, props.subjectfromurl, props.user, getAvailableSubjects]);

    useEffect(() => {
        getTopics(props.gradefromurl! as Subject, props.subjectfromurl!).then((topics) => {
            setTopics(topics.map((topic) => topic.tname));
            console.log("topics: ", topics);
            setSubtopics(topics.reduce((acc: { [topic: string]: string[] }, topic) => {
                acc[topic.tname] = topic.subtopics;
                return acc;
            }, {}));
        });
    }, [props.gradefromurl, props.subjectfromurl]);

    useEffect(() => {
        getAppUser(props.user?.uid!).then((AppUser) => setAppUser(AppUser));
    }, [props.user]);

    useEffect(() => {
        if (props.subjectfromurl !== null && props.gradefromurl !== null) {
            setSubject(props.subjectfromurl);
            setGrade(props.gradefromurl);
            // setGradeForAlert(gradefromurl);
            // setSubjectForAlert(subjectfromurl);
        }
    }, [props.subjectfromurl, props.gradefromurl]);

    const [isTopicsContentVisible, setIsTopicsContentVisible] = useState(false);
    const handleToggleTopicsContent = () => {
        setIsTopicsContentVisible(!isTopicsContentVisible);
    };

    const handleConfirmDelete = async () => {
        if (!pendingDelete) return;
        if (pendingDelete.type === 'topic') {
            await handleDeleteTopic(pendingDelete.topic);
        } else if (pendingDelete.type === 'subtopic' && pendingDelete.index !== undefined) {
            await handleDeleteSubtopic(pendingDelete.topic, pendingDelete.index);
        }
        setPendingDelete(null);
    };

    if (appUser && (appUser.isAdmin || appUser?.accesslevel === "teacher") && (props.subjectfromurl !== null && props.gradefromurl !== null)) {
    return(
        <>
            <div className="admin-widget">
                <div className="admin-widget-title" onClick={handleToggleTopicsContent}>
                    <b>📂 {t("admin.add-topic")}</b>
                </div>

                <div className={`admin-widget-content ${isTopicsContentVisible ? 'visible' : ''}`}>
                    <hr />
                    <div className="admin-subwidget">
                        <b>{t("admin.topics")}</b>
                        {/* {(props.subjectfromurl === null && props.gradefromurl === null) && 
                            <> */}
                                <div className="admin-input-wrapper">
                                    <label htmlFor="class"><b>{t("admin.grade")}</b></label>
                                    <select className="admin-dropdown" name="class" id="class-select" required defaultValue={props.gradefromurl as string}
                                        onChange={(e) => setGrade(e.target.value)}>
                                        <option value="Prep">{t("subjectpage.prep")}</option>
                                        <option value="9">9{t("subjectpage.thgrader")}</option>
                                        <option value="10">10{t("subjectpage.thgrader")}</option>
                                        <option value="11">11{t("subjectpage.thgrader")}</option>
                                        <option value="12">12{t("subjectpage.thgrader")}</option>
                                    </select>
                                </div>
                                <div className="admin-input-wrapper">
                                    <label htmlFor="subject"><b>{t("admin.subject")}</b></label>
                                    {grade !== '' &&
                                        <select className="admin-dropdown" name="subject" id="subject-select" required defaultValue={props.subjectfromurl as string}
                                            onChange={(e) => { setSubject(e.target.value as Subject); console.log(e.target.value); }}>
                                            {availableSubjects && availableSubjects.map((subject) => (
                                                <option key={subject} value={subject.replace(/\s/g, '').toLowerCase()}>
                                                    {subject}
                                                </option>
                                            ))}
                                        </select>}
                                </div>
                            {/* </>
                        } */}
                        

                        <div className="subtopics-wrapper">
                            {Object.keys(subtopics).map((topic: string) => (
                                // map all topics as input fields (help)

                                <div key={topic} className="topic-item">
                                    {/* Topic header row: name + delete topic button together */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                        {editingInfo.topic === topic ? (
                                            <>
                                                <input
                                                    className="admin-input"
                                                    type="text"
                                                    value={editingInfo.newName || ''}
                                                    onChange={(e) => setEditingInfo({ ...editingInfo, newName: e.target.value })}
                                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSaveTopic(topic, editingInfo.newName || ''); } }}
                                                    style={{ flex: 1 }}
                                                    autoFocus
                                                />
                                                <button
                                                    className="add-button hover-up"
                                                    type="button"
                                                    onClick={() => handleSaveTopic(topic, editingInfo.newName || '')}
                                                    style={{ marginLeft: 6, flexShrink: 0 }}
                                                >✓</button>
                                            </>
                                        ) : (
                                            <span onClick={() => handleEditTopic(topic)} style={{ cursor: 'pointer', flex: 1 }}>
                                                ✨ <b style={{ color: "var(--accent-color)" }}>{topic}</b> <EditIcon style={{ fontSize: 14, verticalAlign: 'middle' }} />
                                            </span>
                                        )}
                                        <button
                                            className="admin-delete-button"
                                            onClick={() => setPendingDelete({ type: 'topic', topic, label: topic })}
                                            title={`Delete topic "${topic}"`}
                                            style={{ marginLeft: 8, flexShrink: 0 }}
                                        >
                                            <DeleteIcon />
                                        </button>
                                    </div>

                                    {/* Subtopics */}
                                    <div className="subtopics-wrapper">
                                        {subtopics[topic].map((subtopic: string, index: number) => (
                                            <div key={index} className="subtopic-item">
                                                {editingSubtopicInfo.topic === topic && editingSubtopicInfo.index === index ? (
                                                    <>
                                                        <input
                                                            className="admin-input"
                                                            type="text"
                                                            value={editingSubtopicInfo.newName || ''}
                                                            onChange={(e) => setEditingSubtopicInfo({ ...editingSubtopicInfo, newName: e.target.value })}
                                                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSaveSubtopic(topic, editingSubtopicInfo.index ?? 0, editingSubtopicInfo.newName || ''); } }}
                                                            style={{ flex: 1 }}
                                                            autoFocus
                                                        />
                                                        <button
                                                            className="add-button hover-up"
                                                            type="button"
                                                            onClick={() => handleSaveSubtopic(topic, editingSubtopicInfo.index ?? 0, editingSubtopicInfo.newName || '')}
                                                            style={{ marginLeft: 6, flexShrink: 0 }}
                                                        >✓</button>
                                                    </>
                                                ) : (
                                                    <span onClick={() => handleEditSubtopic(topic, index)} style={{ cursor: 'pointer', flex: 1 }}>
                                                        {subtopic} <EditIcon style={{ fontSize: 12, verticalAlign: 'middle', opacity: 0.5 }} />
                                                    </span>
                                                )}
                                                <button
                                                    className="admin-delete-button"
                                                    onClick={() => setPendingDelete({ type: 'subtopic', topic, index, label: subtopic })}
                                                    title={`Delete subtopic "${subtopic}"`}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </div>
                                        ))}

                                        {/* Add subtopic row */}
                                        <div className="admin-input-wrapper" style={{ marginTop: 6 }}>
                                            <input
                                                className="admin-input"
                                                type="text"
                                                name="subtopic"
                                                value={subtopicInputs[topic] || ''}
                                                onChange={(e) => setSubtopicInputs({ ...subtopicInputs, [topic]: e.target.value })}
                                                onKeyDown={(e) => e.key === 'Enter' && handleAddSubtopic(topic)}
                                                placeholder={`+ ${t("admin.newsubtopic")}`}
                                            />
                                            <button className="add-button hover-up" onClick={() => handleAddSubtopic(topic)} title="Add subtopic">
                                                &nbsp;+&nbsp;
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className="admin-input-wrapper">
                                <input
                                    className="admin-input"
                                    type="text"
                                    name="topic"
                                    value={newTopic}
                                    onChange={(e) => setNewTopic(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleAddTopic()}
                                    placeholder={`+ ${t("admin.newtopic")}`}
                                />
                                <button className="add-button hover-up" onClick={handleAddTopic} title="Add topic">
                                    &nbsp;+&nbsp;
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {pendingDelete && (
                <DeleteConfirmModal
                    name={pendingDelete.label}
                    onConfirm={handleConfirmDelete}
                    onCancel={() => setPendingDelete(null)}
                />
            )}
        </>
    )
    } else {
        return null;
    }
    
}

export default TopicsPage;